// let cn = require('china-region');//引入中国地区接口
import { addEmploymentReservation } from "@/api/reservation/reservation.js";
import { validPhone, validEmail } from "@/utils/validate";
let productOptions = [
  {
    value: "防爆四足机器人-X3 STABLE",
    label: "防爆四足机器人-X3 STABLE",
  },
  {
    value: "防爆轮式机器人-SGLS-C3",
    label: "防爆轮式机器人-SGLS-C3",
  },
  {
    value: "防爆轮式机器人-L4-S",
    label: "防爆轮式机器人-L4-S",
  },
];
let intentionOptions = [
  {
    value: "“悦享”服务",
    label: "“悦享”服务",
  },
  {
    value: "“智享”服务",
    label: "“智享”服务",
  },
  {
    value: "“尊享”服务",
    label: "“尊享”服务",
  },
  {
    value: "“优享”服务",
    label: "“优享”服务",
  },
];
export default {
  components: {},
  data() {
    // 邮箱校验
    let validateEmail = (rule, value, callback) => {
      if (!validEmail(value)) {
        callback(new Error("请输入正确的邮箱"));
      } else {
        callback();
      }
    };
    // 手机号校验
    let validatePhone = (rule, value, callback) => {
      if (!validPhone(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      form: {},
      productOptions,
      intentionOptions,
      formRules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        corporateName: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: "blur",
          },
        ],
        phone: [
          {
            validator: validatePhone,
            trigger: "blur",
            required: true,
          },
        ],
      },
      orderLoading: false,
      todayNumber: 0,
    };
  },
  mounted() {
    let userInfo = this.$store.state.user.userInfo || null;
    if (userInfo) {
      this.form = {
        name: userInfo.userName,
        phone: userInfo.phonenumber,
        corporateName: userInfo.corporateName,
      };
    }
    this.todayNumber=this.getDailyIncrementalValue();
  },
  methods: {
    getDailyIncrementalValue() {
      // 获取当前时间
      const now = new Date();
      // 计算当天0点的时间
      const startOfDay = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );
      // 计算从当天0点到当前时间经过的毫秒数
      const elapsedMs = now - startOfDay;
      // 计算当天的总毫秒数（24小时）
      const totalMsInDay = 86400000;
      // 计算递增比例（0到1之间）
      const progress = elapsedMs / totalMsInDay;
      // 计算当前值（1到50之间）
      let value = 1 + progress * 49;
      // 确保最大值不超过50
      value = Math.min(value, 50);
      // 四舍五入取整
      return Math.round(value);
    },

    //打电话
    openDial() {
      window.location.href = "tel:400-8765-700";
    },
    // 预约留资
    async orderNow() {
      // 后续考虑同步crm
      this.orderLoading = true;
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let res = await addEmploymentReservation(this.form);
          if (res.code === 200) {
            this.$message.success("预约成功！");
            this.orderLoading = false;
          } else {
            this.$message.error("预约失败，请联系电话预约");
            this.orderLoading = false;
          }
        } else {
          this.$message.error("请填写必填项！");
          this.orderLoading = false;
        }
      });
    },
  },
};
